import React from 'react';
import {observer} from 'mobx-react-lite';
import Loader from '@src/components/shared/loader/loader';
import {useStores} from '@src/components/store';
import {PresetItem} from './preset-item';
import './presets-bronze.scss';

/** Inline panel rendered above the categories list when the preset button is active. */
export const PresetBronzePanel: React.FC = observer(() => {
    const {fwVersionBronzeStore} = useStores();
    const {presets, presetsLoading} = fwVersionBronzeStore;

    return (
        <div className="preset-bronze-panel">
            <div className="presets-text">
                <p className="presets-header">Categories presets</p>
                <p className="presets-body">Turn on one of the presets below to block its categories</p>
            </div>
            {presetsLoading ? (
                <Loader type="component"/>
            ) : (
                <div className="presets-items">
                    {presets.map(preset => (
                        <PresetItem key={preset.groupId} preset={preset}/>
                    ))}
                </div>
            )}
        </div>
    );
});
